import React from 'react';
import PropTypes from 'prop-types';

import { getAsset } from '../../../../../../../util/assets';

const propTypes = {
  hasFilters: PropTypes.bool,
};

const IdentityNullState = ({ identity, hasFilters }) => {
  return (
    <div className="d-flex flex-column align-items-center mt-3">
      <img
        src={getAsset('/waldo-icon.svg')}
        className="grayscale-faded mb-3"
        width="40"
        alt="Waldo Icon"
      />
      <h3 className="text-extra-bold text-center mb-1">
        {hasFilters
          ? 'No matches found for the selected tags.'
          : 'No matches found yet!'}
      </h3>
      {hasFilters && (
        <p className="m-0 text-light text-bold text-center">
          Clear the selected filters by clicking on the highlighted tags above
          and see all your matches!
        </p>
      )}
      {!hasFilters && identity && (
        <p className="m-0 text-light text-bold text-center">
          I&rsquo;ll send you an alert the moment I find your matching photos in
          this event!
        </p>
      )}
    </div>
  );
};

IdentityNullState.propTypes = propTypes;

export default IdentityNullState;
